import { render } from "./spinner.vue?vue&type=template&id=16927bcc&ts=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jason/.local/share/cdd/projects/default/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__